export default "__VITE_ASSET__Brdh9lcM__"